export default __webpack_public_path__ + "static/case1_img_3@2x-21f3e231af7edbd8cdd6b931dbb5aba1.webp";